import React from 'react'
import { Grid} from 'semantic-ui-react'
import _ from 'lodash'
import InputField from '../../../formComponents/inputField'
import { Loader} from 'semantic-ui-react'

const AdditionDeductionFields=({className='',additions,deletions,onUpdate,onSave,isLoading,id,disabled,...rest})=> {
 const renderField=({label,objectKey,field})=>{
  return (
    <div style={{position:'relative'}}>
     
    <InputField 
    label={label}
    type='text'
    className="field-bg"
    id={`${id}-${field}`}
    handleFocus={(e) => {
      e.target.select();
    }}
    subLabelText='$'
    subLabelClass='left-icon'
    value={field=="totalAdditions" ? additions?.[field]: deletions?.[field]}
    isInteger={true}
    onChange={(value)=>onUpdate(value,objectKey,field)}
    onBlur={value=>onSave(value,objectKey,field)
    }
    disabled={disabled}
    {...rest}
  />
  </div>
  )
}

   
    return (
      <Grid.Row className={`merged hts-row finalRowz ${className}`}>
          {
            isLoading && <div 
                                className='loader' 
                                style={{
                                  fontSize:"large",
                                  height:"100vh", 
                                   width:"100vw", 
                                  position:"absolute", 
                                  zIndex:'4',
                                  background: "white",
                                  opacity: "0.5",
                                  backdropFilter: "blur(20px)",
                                  WebkitBackdropFilter: "blur(20px)", // for Safari support
                              }} >  <Loader style={{position:'absolute',top:'10px',left:'30%'}} active><b>Loading...</b></Loader>
                              </div>
      }
        <Grid.Column className="no-field-margin" width="8">
           {renderField({label:"Total Additions",objectKey:"additions",field:"totalAdditions"})}
           
        </Grid.Column>
        <Grid.Column className="no-field-margin borderEnd" width="8">
           {renderField({label:"Total Deductions",objectKey:"deletions",field:"totalDeletions"})}
           
        </Grid.Column>
      </Grid.Row>
        
    )
  }
export default AdditionDeductionFields